import { render } from "./CollectionCardAny.vue?vue&type=template&id=4c1b3d46"
import script from "./CollectionCardAny.vue?vue&type=script&lang=js"
export * from "./CollectionCardAny.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__